/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q7Inputs */

const en_diff_faq_q7 = /** @type {(inputs: Diff_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does formatting or key order affect the result?`)
};

const ko_diff_faq_q7 = /** @type {(inputs: Diff_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서식이나 키 순서가 결과에 영향을 주나요?`)
};

const ja_diff_faq_q7 = /** @type {(inputs: Diff_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書式やキー順序は結果に影響しますか`)
};

/**
* | output |
* | --- |
* | "Does formatting or key order affect the result?" |
*
* @param {Diff_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q7 = /** @type {((inputs?: Diff_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q7(inputs)
	if (locale === "ko") return ko_diff_faq_q7(inputs)
	return ja_diff_faq_q7(inputs)
});